<div class="am-flex-align am-flex-shrink-0 bb-grey">
  @for (t of types; track t.type) {
    <span class="am-flex-1 am-flex-center gap-xxs height-36 font-s font-500 pointer" [ngClass]="bulkType === t.type ? 'bb-blue-2 color-blue' : 'bb-white-2 color-secondary-grey hover-active'" [class.events-none]="message" [class.color-disabled]="message && bulkType !== t.type" (click)="changeBulkType(t.type)">
      <span class="am-flex-center font-l" [ngClass]="t.icon"></span>
      <span>{{ t.label }}</span>
    </span>
  }
</div>

@if (!message) {
  <div class="pl-s pr-s pt-xs pb-xs bb-grey">
    <pagination-search [secondary]="'bulkNew'" (callback)="reloadEntries()"></pagination-search>
  </div>

  <div class="am-flex-column am-flex-1 font-s overflow-auto">
    @if (bulkType === 'room') {
      @for (room of rooms; track room.id) {
        <span class="am-flex-align pl-s pr-s pt-xxs pb-xxs bb-grey pointer" [ngClass]="room.active ? 'bg-table-header-grey' : 'hover-active-bg'" (click)="select(room, $event)">
          <input class="custom-checkbox blue small" type="checkbox" [id]="'room'+room.id" [(ngModel)]="room.active">
          <label [for]="'room'+room.id" class="gap-xs pointer">
            <span class="circle-xxl am-flex-center color-white font-xs font-500 uppercase" [ngClass]="room | avatarColor">{{ room.owner?.initials }}</span>
            <span class="font-500">{{ room.roomName }}</span>
          </label>
        </span>
      }
    } @else if (bulkType === 'location') {
      @for (entry of locations; track entry.id) {
        <span class="am-flex-align gap-xs pl-s pr-s pt-xs pb-xs bb-grey pointer" [ngClass]="activeLocation?.id === entry.id ? 'bg-table-header-grey color-blue' : 'hover-active-bg'" (click)="select(entry)">
          <span class="am-flex-center circle-s circle-i" [ngClass]="activeLocation?.id === entry.id ? 'b-blue bg-blue' : 'b-grey'"></span>
          <span class="font-500">{{ entry.city }}</span>
          <span class="color-secondary-grey">({{ entry.identifier }})</span>
        </span>
      }
    } @else if (bulkType === 'company') {
      @for (entry of companies; track entry.id) {
        <span class="am-flex-align gap-xs pl-s pr-s pt-xs pb-xs bb-grey pointer" [ngClass]="activeCompany?.id === entry.id ? 'bg-table-header-grey color-blue' : 'hover-active-bg'" (click)="select(entry)">
          <span class="am-flex-center circle-s circle-i" [ngClass]="activeCompany?.id === entry.id ? 'b-blue bg-blue' : 'b-grey'"></span>
          <span class="font-500">{{ entry.name }}</span>
        </span>
      }
    }
  </div>

  @if (meta?.total_pages > 1) {
    <div class="pl-s pr-s pt-xs pb-xs bt-grey">
      <pagination-secondary [totalPages]="meta?.total_pages" [page]="meta?.current_page" [total]="meta?.total_count" [perPage]="meta?.per_page" (callback)="reloadEntries($event)"></pagination-secondary>
    </div>
  }
}

<div class="am-flex-column gap-xxs pl-s pr-s pt-xs pb-xs bt-grey bg-table-header-grey" [class.am-flex-1]="message">
  <div class="am-flex-align gap-xs">
    <span class="font-s font-500">Ausgewählt ({{ selectedNames.length }})</span>
    @if (!message && selectedNames.length) { <span class="mla font-xs font-500 color-secondary-grey pointer hover-active" (click)="clearSelection()">Alle entfernen</span> }
  </div>
  <div class="am-flex-wrap gap-xxs">
    @for (name of selectedNames; track $index) {
      <span class="am-flex-align gap-xxs height-l pl-xs b-radius-wide bg-light-blue color-blue font-xs font-500" [ngClass]="message ? 'pr-xs' : 'pr-xxs'">
        <span>{{ name }}</span>
        @if (!message) { <span class="am-flex-center circle-m icon-cross font-xs pointer hover-bg-soft-red" title="Entfernen" (click)="remove($index)"></span> }
      </span>
    } @empty { <span class="font-xs color-secondary-grey">Noch niemand ausgewählt</span> }
  </div>
</div>

<div class="am-flex-column gap-xs bt-grey p-s">
  <textarea class="resize-none" [(ngModel)]="messageInput" rows="3" placeholder="Geben Sie hier Ihre Nachricht ein"></textarea>
  <div class="am-flex-align gap-xs">
    <span class="font-xs color-secondary-grey">{{ messageInput?.length || 0 }} Zeichen</span>
    <span class="mla am-flex-center gap-xs height-36 pl-s pr-s bg-blue b-radius color-white font-s font-500" [ngClass]="canSubmit ? 'pointer hover-bg-light-blue' : 'opacity-50 events-none'" (click)="submitHandler()">
      <span class="am-flex-center icon-send font-l"></span>
      <span>{{ submitLabel }}</span>
    </span>
  </div>
</div>

@if (loading) {
  <div class="absolute-full bg-overlay-white events-none wait-animation">
    <div class="am-flex-center">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
}
